import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    const errorMessages = checkItemArrayIntegrity(items, ["id", "headline"]);

    return errorMessages;
}
